import { APIClient } from "../base";
import { PaginationInterface } from "../../../interfaces/PaginationInterface";

const LogApi = {
    getAll: async (pagination: PaginationInterface) => await APIClient.get('/logs', pagination),
    getDetail: async (id: number | string | any) => await APIClient.get('/logs/' + id, {}),
}

export default LogApi;
